<template>
    <div class="main-content">
        <list
            :columns="columns"
            :rows="records"
            :select-options="{
                enabled: false,
            }"
            :pagination-options="{
                perPage: 20,
            }"
        />
    </div>
</template>

<script>
import api from '@/api/api'
import auth from '@/firebase/auth'

export default {
    name: 'ReportFeedbacks',
    components: {
        List: () => import('@/components/List/List'),
    },
    data () {
        return {
            records: [],
            date: '',
            columns: [
                {
                    label: 'Sentimento',
                    field: 'emoji',
                    width: '200px',
                },
                {
                    label: 'Comentário',
                    field: 'description',
                },
            ],
        }
    },
    created () {
        const dynamicColumns = [
            {
                label: 'ID',
                field: 'uid',
                width: '150px',
            },
            {
                label: 'Usuário',
                field: 'name',
                width: '150px',
            },
        ]

        auth
            .currentUser
            .getIdToken()
            .then((token) => {
                api
                    .get('/reports/feedbacks', {
                        headers: {
                            token,
                        },
                        params: {
                            responseId: this.$route.params.id,
                        },
                    })
                    .then(response => {
                        if (!response.data.records || !response.data.records.length) return

                        this.date = response.data.createdDate
                        this.records = response.data.records

                        const hasColumnUid = this.records.some((item) => {
                            return item.uid
                        })

                        const hasColumnName = this.records.some((item) => {
                            return item.name
                        })

                        if (hasColumnName) {
                            this.columns = [
                                ...dynamicColumns.slice(1),
                                ...this.columns,
                            ]
                        }

                        if (hasColumnUid) {
                            this.columns = [
                                ...dynamicColumns.slice(0, 1),
                                ...this.columns,
                            ]
                        }
                    })
            })
            .catch(err => console.log(err))
    },
}
</script>
